define([
    "dojo/_base/declare",
    "csi/_base/underscore",
    "csi/datasheet/Widget",
    "./SelectSetHelper"
], function(declare,_,DataSheetWidget,SelectSetHelper) {

	var FIXED_VIEWS = {
		Properties: 1,
		TitleBlock: 1
	};

    return declare(DataSheetWidget, {
		_resolveView: function() {
			// summary: set the target for relationship to the class of the type
			var type = SelectSetHelper.getSubtypeName(this.getViewNode());
			if (type) {
				var	idTable = SelectSetHelper.SELECT_SET_TYPE_ITEMS_VIEW_DEF[type];
				var	idGallery = SelectSetHelper.SELECT_SET_TYPE_ITEMS_GALLERY_DEF[type];
				var defView = this.defView;
				var omit = [];
				var galleryViewRef;
				var tableViewRef;

				_.each(defView.defsByKey, function(viewRef, key) {
					if (key == idGallery) {
						viewRef.bReadOnly = true;
						galleryViewRef = viewRef;
					} else if (key == idTable) {
						viewRef.bReadOnly = true;
						tableViewRef = viewRef;
					} else if (!FIXED_VIEWS[key]) {
						omit.push(viewRef);
					}
				});

				defView.setResourceKey(galleryViewRef, "ItemsGallery", true);
				defView.setResourceKey(tableViewRef, "SelectSetItems", true);

				_.each(omit, function(viewRef) {
					defView.removeResource(viewRef);
				});

				this.prefKey = defView.getKey(type);
			}

			this.inherited(arguments);
		}
    });
});